import { Injectable } from '@angular/core';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { FindPersonApiService } from '@tangilla/tg-ng-core';
import { PersonRelationship, RequestParameters } from '@tangilla/tg-ng-models';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';

@Injectable({
  providedIn: 'root'
})
export class NvtVendorService {

    isLoading = true;
    formatter: Intl.NumberFormat | any;

    constructor(
      private surveyService: SurveyService,
      private findPersonApiService: FindPersonApiService,
      private errorsService: ErrorsService
    ) {
    }


  initializeForm() {
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    this.initializeOnAfterRenderPage();
    this.initializeOnValueChanged();
  }

  initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch(currentPage.name) {
        case "Vendors":
          this.surveyService.surveyModel.setValue("role", 'NVT');
          this.surveyService.surveyModel.setValue("association_product_type", '');
          this.surveyService.surveyModel.setValue("product_type_desc", 'Vendor/Trainer');
          this.surveyService.surveyModel.setValue("MembershipType", 'Non-Member');
          break;
      }
    })
  }

  initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add( (sender, options) => {
      if(options.name === 'emailaddress' && !this.surveyService.surveyModel.getQuestionByName("LastName").isEmpty()){
        var lastName = this.surveyService.surveyModel.getValue("LastName");
        // getPersonbyEmail(options.value, last_name, procPersonbyObj, errPersonbyObj);
        const requestParameters = new RequestParameters(null);
        requestParameters.additionalFields = {
          last_name: lastName,
          email: options.value
        }
        this.findPersonApiService.get(requestParameters).subscribe({
          next: (response: any) => {
            if(response.length > 0){
              const active_relationships = response.find( (p : any) => p.relationships.some((r:PersonRelationship) => ['active','terminated_by_broker'].includes(r.status)))
              if(active_relationships) {
                this.errorsService.exitForm(`Profile Already Exists`,`The details provided (email or phone) are associated with an active profile, a new profile cannot be created.`);
              }
            }else{
            this.surveyService.surveyModel.setValue("person_id", null); //should not get to here.
            }
          },
          error: (error: any) => {
            this.errorsService.processError(error);
          }
        })
      }
    })
  }

}